import { useNavigate } from "react-router-dom";
import { Kicker } from "./bits";
import { T, CLUB_TIERS } from "./content";
import { useNoIndex } from "./hooks";

const STRIPE_KEY = { I: "premium", II: "or", III: "diamant" };

function MaskedTitle({ lines, className = "" }) {
  return (
    <h1 className={`display ${className}`}>
      {lines.map((line, li) => (
        <div className="line-mask" key={li}>
          <span>
            {line.map((seg, si) =>
              si % 2 === 1 ? (
                <em key={si} className="accent">
                  {seg}
                </em>
              ) : (
                seg
              )
            )}
          </span>
        </div>
      ))}
    </h1>
  );
}

function AdhesionCard({ tier, lang, cta }) {
  const name = lang === "fr" ? tier.nameFr : tier.nameEn;
  const price = lang === "fr" ? tier.priceFr : tier.priceEn;
  const tagline = lang === "fr" ? tier.taglineFr : tier.taglineEn;
  return (
    <article
      className={`club-card adh-card ${tier.invert ? "club-card--invert" : ""}`}
      data-testid={`adhesion-tier-${tier.rank}`}
    >
      <span className="club-rank">{tier.rank}</span>
      <h3 className="club-name">{name}</h3>
      <span className="club-price">{price}</span>
      <span className="club-tagline">{tagline}</span>
      <a
        className="adh-pay"
        href="#"
        data-stripe-link={STRIPE_KEY[tier.rank]}
        data-testid={`adhesion-pay-${tier.rank}`}
      >
        {cta}
      </a>
    </article>
  );
}

export default function Adhesion({ lang }) {
  const t = T[lang];
  useNoIndex();
  useNavigate(); // ensures router context is present

  return (
    <main className="site" data-testid="adhesion-main">
      <section className="section adhesion">
        <div className="container">
          <div className="section-head reveal">
            <Kicker withDash>{t.adhesionKicker}</Kicker>
            <MaskedTitle lines={t.adhesionTitle} className="adhesion-title" />
            <p className="lead reveal">{t.adhesionLead}</p>
          </div>

          <div className="club-grid adhesion-grid">
            {CLUB_TIERS.map((tier) => (
              <AdhesionCard key={tier.rank} tier={tier} lang={lang} cta={t.adhesionCta} />
            ))}
          </div>

          <p className="adhesion-legal reveal">{t.adhesionLegal}</p>
        </div>
      </section>
    </main>
  );
}
